import { IErrorService } from "../../abstractions/services/IErrorService";
import { ILayoutService } from "../../abstractions/services/ILayoutService";
import { errorService } from "../services/ErrorService";
import { fincaSelectedService } from "../services/FincaSelectedService";
import { modalZIndexService } from "../services/components/ModalZIndexService";
import { IModalZIndexService } from "../../abstractions/services/components/IModalZIndexService";
import { IFincaSelectedService } from "../../abstractions/services/IFincaSelectedService";

/** Proveedor central de servicios (singleton `serviceProvider`). Expone los
 *  servicios de la app como interfaces. */
export class ServiceProvider {
  /** Servicio de z-index de modales. */
  getModalZIndexService(): IModalZIndexService {
    return modalZIndexService;
  }

  /** Servicio de notificaciones/errores. */
  getErrorService(): IErrorService {
    return errorService;
  }

  /** Contexto de la finca seleccionada. */
  getFincaSelectedService(): IFincaSelectedService {
    return fincaSelectedService;
  }

  /** Servicio de layout (registrado por `AppComponent` vía `setLayoutService`). */
  private _layoutService: ILayoutService | null = null;

  /** Retorna el servicio de layout; lanza si aún no fue registrado. */
  getLayoutService(): ILayoutService {
    if (this._layoutService) {
      return this._layoutService;
    }
    throw new Error("debe llamar ServiceProvider.setLayoutService");
  }

  /** Registra el servicio de layout (lo hace `AppComponent` al inicializarse). */
  setLayoutService(layoutService: ILayoutService) {
    this._layoutService = layoutService;
  }
}

/** Singleton del proveedor de servicios. Llamar `serviceProvider.init(apiBaseRoute)`
 *  una vez en el bootstrap antes de cualquier uso. */
export const serviceProvider = new ServiceProvider();
